import React, {Component} from 'react'
import * as colors from '../colors'
import {style} from 'glamor'
import {TimelineMax, TweenMax} from 'gsap'

const duration = 0.7
const ease = TweenMax.Expo.easeOut

export default class Reveal extends Component {

  componentDidMount(){
    // this.getAnimationIn()
  }

  getAnimationIn(){
    return new TimelineMax()
    // .fromTo(this.refs.content, duration, {
    //     // x: 100,
    //     opacity: 0,
    //   },{
    //     // x: 0,
    //     opacity: 1,
    //     ease: ease
    //   })
  }

  getAnimationOut(){
    return new TimelineMax()
      // .fromTo(this.refs.content, duration, {
      //   // x: 0,
      //   opacity: 1
      // },{
      //   opacity: 0,
      //   // x: 100,
      //   ease: TweenMax.Expo.easeIn
      // })
  }

  render(){
    const {children, color = colors.yellow, ...props} = this.props
    return (
      <div {...props}>

            {children}

      </div>
    )
  }
}



/** WEBPACK FOOTER **
 ** ./src/components/Reveal.js
 **/